import PostListPage from '~components/post-list-page'

export default PostListPage({
  path: '/new',
  title: 'Posts nuevos',
  sort: '-dateCreated'
})



// WEBPACK FOOTER //
// ../frontend/pages/post/list-new.js